import React from 'react';
import CoWorkingNewsList from '../components/CoWorkingNewsList';

const News: React.FC = () => {
    return (
        <div className="w-full px-4 py-8 max-w-7xl mx-auto text-[#2C2E35]">
            <CoWorkingNewsList showButton={false} addMargin={true} />
        </div>
    );
};

export default News;
